var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('swiper',_vm._l((_vm.banners),function(item,index){return _c('swiper-item',{key:index},[_c('img',{staticClass:"banner",attrs:{"src":item.url,"alt":""}})])}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }